import { useState, useEffect } from 'react';
import { Check, Circle } from 'lucide-react';

interface PartnerPasswordRulesProps {
  password: string;
  rules: Record<string, string>;
}

interface Rules {
  [key: string]: boolean;
}

export function PartnerPasswordRules({ password = '', rules }: PartnerPasswordRulesProps) {
  const [localRules, setLocalRules] = useState<Rules>({});

  useEffect(() => {
    if (password) {
      const newRules: Rules = {};

      Object.keys(rules).forEach((rule) => {
        try {
          const regex = new RegExp(rule);
          newRules[rule] = regex.test(password);
        } catch {
          newRules[rule] = false;
        }
      });

      setLocalRules(newRules);
    } else {
      const emptyRules: Rules = {};
      Object.keys(rules).forEach((rule) => {
        emptyRules[rule] = false;
      });
      setLocalRules(emptyRules);
    }
  }, [password, rules]);

  const renderIcon = (isValid: boolean) => {
    return isValid ? (
      <Check className="h-3 w-3 stroke-muted-foreground" />
    ) : (
      <Circle className="h-3 w-3 stroke-muted-foreground" />
    );
  };

  const renderRequirement = (isValid: boolean, text: string) => (
    <li className="flex items-center gap-2">
      {renderIcon(isValid)}
      <span className="text-muted-foreground">
        {text}
      </span>
    </li>
  );

  return (
    <div className="mt-8 text-xs">
      <p className="text-muted-foreground mb-2">
        Crie uma senha segura. Ela deve conter:
      </p>
      <ul className="mt-1 space-y-1">
        {Object.entries(rules).map(([rule, text]) => (
          <li key={rule}>
            {renderRequirement(localRules[rule] || false, text)}
          </li>
        ))}
      </ul>
    </div>
  );
}
